export const urls = {
  settings: {
    profile: {
      href: "/settings/profile",
    },
    limits: {
      href: "/settings/limits",
    },
    href: "/settings",
  },
  signIn: {
    href: "/public/signin",
  },
  signOut: {
    href: "/api/auth/signout",
  },
  sendMoney: {
    start: {
      href: "/send-money?step=start",
    },
  },
  beneficiaries: {
    href: "/beneficiaries",
    beneficiary(id: number) {
      return {
        href: `${this.href}/${id}`,
        edit: {
          href: `${this.href}/${id}/edit`,
        },
      };
    },
  },
} as const;
